/* TrustSignalsSection.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _10 = "._y3gn1h6o{text-align:center}";
const _9 = "@media (min-width:64rem){._1rqt1ezz{grid-template-columns:repeat(4,1fr)}._pdlmhiv4{gap:var(--ds-space-400)}}";
const _8 = "@media (min-width:48rem){._1j8bfsjm{grid-template-columns:repeat(2,1fr)}._19wgl6l0{gap:var(--ds-space-300)}}";
const _7 = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
const _6 = "._zulpl6l0{gap:var(--ds-space-300)}";
const _5 = "._yv0e1ttp{grid-template-columns:repeat(1,1fr)}";
const _4 = "._1e0c11p5{display:grid}";
import { media } from '@atlaskit/primitives/responsive';
import { BodyLarge, H3 } from '@atlassian/mpac-primitives';
import React from 'react';
import { trustSignals } from './constants';
import { TrustSignalCard } from './TrustSignalCard';
const _3 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _2 = "._otyr1ejb{margin-bottom:var(--ds-space-300,24px)}";
const _ = "._19pkpxbi{margin-top:var(--ds-space-200,1pc)}";
const Description = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodyLarge,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pkpxbi _otyr1ejb _syaz1k3w", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
const TrustSignalsWrapper = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_4, _5, _6, _7, _8, _9]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c11p5 _yv0e1ttp _zulpl6l0 _otyrxy5q _1j8bfsjm _19wgl6l0 _1rqt1ezz _pdlmhiv4", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  TrustSignalsWrapper.displayName = 'TrustSignalsWrapper';
}
const SectionHeader = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_10]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_y3gn1h6o", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SectionHeader.displayName = 'SectionHeader';
}
export const TrustSignalsSection = () => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SectionHeader, null, /*#__PURE__*/React.createElement(H3, null, "One platform, Countless Opportunities!"), /*#__PURE__*/React.createElement(Description, null, "Build and distribute trusted and enterprise-ready cloud apps - while Atlassian takes care of security, compute and storage")), /*#__PURE__*/React.createElement(TrustSignalsWrapper, null, trustSignals.map(trustSignal => {
    const {
      id,
      stats,
      label,
      cardStyles,
      statsStyles
    } = trustSignal;
    return /*#__PURE__*/React.createElement(TrustSignalCard, {
      key: id,
      stats: stats,
      label: label,
      cardStyles: cardStyles,
      statsStyles: statsStyles
    });
  })));
};